<template>
  <on-click-outside @outside="close">
    <div class="search-select" :class="[bg === 'light' ? 'bg-light' : 'bg-middle']">

      <button ref="button" @click="open" type="button" class="search-select-input" :class="[truncate ? 'truncate' : '']">
        <div class="search-select-input-content">
          <div class="search-select-input-choise f5" :class="{ 'truncate': truncate }">
            <span v-if="value !== null" :class="[upperCase ? 'ttu' : '']">
              {{ labelProvider(options[value]) }}
            </span>
            <span v-else-if="placeholder" class="search-select-placeholder">{{ placeholder }}</span>
            <span v-else class="search-select-placeholder"></span>
          </div>

          <button v-if="value !== null && resetEnabled" @click="reset" class="input-icon-button bg-input-button">
            <font-awesome-icon icon="times" />
          </button>

          <button v-else class="input-icon-button bg-input-button">
            <font-awesome-icon icon="caret-down" />
          </button>
        </div>
      </button>

      <div ref="dropdown" v-show="isOpen" class="search-select-dropdown">
        <div v-if="searchEnabled" class="pa2">
          <input class="search-select-search disabled"
            v-model="search"
            ref="search"
            @keydown.esc="close"
            @keydown.up="highlightPrev"
            @keydown.down="highlightNext"
            @keydown.enter.prevent="selectHighlighted"
            @keydown.tab.prevent
          >
        </div>
        <ul ref="options" v-show="filteredOptions.length > 0" class="search-select-options">
          <li class="search-select-option truncate f6 dim"
            v-for="(option, index) in filteredOptions"
            :key="index"
            @click="select(index)"
            :class="[searchEnabled && index === highlightedIndex ? 'is-active' : '', upperCase ? 'ttu' : '']"
          >{{ labelProvider(option) }}</li>
        </ul>
        <div v-show="filteredOptions.length === 0" class="search-select-empty f6">Ничего не найдено: '{{ search }}'</div>
      </div>

    </div>
  </on-click-outside>
</template>

<script>
import OnClickOutside from './OnClickOutside.vue'
// import Popper from 'popper.js'

export default {
  components: {
    OnClickOutside
  },
  props: {
    value: {
      type: Number,
      default: null
    },
    options: { default: [] },
    placeholder: { default: '' },
    labelProvider: {
      default: () => {
        return (o) => {
          return o ? o.name : o
        }
      }
    },
    filterFunction: {
      default: () => {
        return (search, options) => {
          return options
            ? options
              .filter(option => option.name)
              .filter(option => option.name.toLowerCase().startsWith(search.toLowerCase()))
            : options
        }
      }
    },
    searchEnabled: { default: true },
    resetEnabled: { default: true }, // показывать ли крестик для удаления выбранного значения
    upperCase: { default: false },
    truncate: { default: true },
    bg: { default: 'light' }
  },
  data () {
    return {
      isOpen: false,
      search: '',
      highlightedIndex: 0
    }
  },
  beforeDestroy () {
    // if (this.popper) {
    //  this.popper.destroy()
    //  this.popper = null
    // }
  },
  computed: {
    filteredOptions () {
      const options = this.options
        ? this.options.map((o, i) => { return { ...o, absolute_index: i } })
        : []
      return this.filterFunction(this.search, options)
    }
  },
  methods: {
    open () {
      if (this.isOpen) {
        return
      }
      this.isOpen = true
      this.$nextTick(() => {
        // this.setupPopper()
        if (this.$refs.search) {
          this.$refs.search.focus()
        }
        this.scrollToHighlighted()
      })
    },
    /*
    setupPopper () {
      // чето глючит, открывает список наверх
      if (this.popper === undefined) {
        this.popper = new Popper(this.$refs.button, this.$refs.dropdown, {
          placement: 'bottom',
          strategy: 'absolute'
        })
      } else {
        this.popper.update()
      }
    },
    */
    close () {
      if (!this.isOpen) {
        return
      }
      this.isOpen = false
      this.$refs.button.focus()
    },
    select (index) {
      this.emitSelected(index)
      this.search = ''
      this.highlightedIndex = 0
      this.close()
    },
    reset (e) {
      e.stopPropagation()
      this.select(null)
    },
    selectHighlighted () {
      this.select(this.highlightedIndex)
    },
    scrollToHighlighted () {
      if (this.$refs.options.children[this.highlightedIndex]) {
        this.$refs.options.children[this.highlightedIndex].scrollIntoView({
          block: 'nearest'
        })
      }
    },
    highlight (index) {
      this.highlightedIndex = index

      if (this.highlightedIndex < 0) {
        this.highlightedIndex = this.filteredOptions.length - 1
      }

      if (this.highlightedIndex > this.filteredOptions.length - 1) {
        this.highlightedIndex = 0
      }

      this.scrollToHighlighted()
    },
    highlightPrev () {
      this.highlight(this.highlightedIndex - 1)
    },
    highlightNext () {
      this.highlight(this.highlightedIndex + 1)
    },
    emitSelected (index) {
      const option = Number.isInteger(index) ? this.filteredOptions[index] : index
      this.$emit('input', option ? option.absolute_index : option)
    }
  }
}
</script>

<style lang="scss" scoped>
.search-select {
  position: relative;
}
.search-select-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.search-select-input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
  min-height: 40px;
  background-color: inherit;
  padding: 0 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  outline: none;
  border: none;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
}
.search-select-input-content {
  display: grid;
  grid-template-columns: 1fr 40px;
  grid-template-rows: 180;
  align-items: center;
  text-align: left;
}
.search-select-input:focus {
  outline: 0;
  border-color: #627D98;
}
.search-select-input-choise {
  padding: .5rem .5rem;
}
.search-select-placeholder {
  color: #8795a1;
}
.search-select.is-active .search-select-input {
  -webkit-box-shadow: 0 0 0 3px rgba(52, 144, 220, 0.5);
  box-shadow: 0 0 0 3px rgba(52, 144, 220, 0.5);
}
.search-select-dropdown {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  position: absolute;
  right: 0;
  left: 0;
  background-color: white;
  padding: 0;
  -webkit-box-shadow: 0 4px 4px 2px rgba(0, 0, 0, 0.2);
  box-shadow: 0 4px 4px 2px rgba(0, 0, 0, 0.2);
  z-index: 50;
}
.search-select-search {
  display: block;
  margin-bottom: 0.5rem;
  padding: 0.5rem 0.5rem;
  width: 100%;
  background-color: white;
  border-color: silver;
  border-width: 1px 1px 1px 1px;
  color: #334E68;
  border-top-style: solid;
  border-right-style: solid;
  border-left-style: solid;
  border-bottom-style: solid;
}
.search-select-search:focus {
  outline: 0;
}
.search-select-options {
  list-style: none;
  padding: 0;
  margin: 0;
  position: relative;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  max-height: 14rem;
}
.search-select-option {
  margin: 0;
  padding: 0.8rem 0.5rem;
  color: #334E68;
  border-left: 0;
  border-right: 0;
  border-top: 0px;
  border-bottom: 1px;
  border-style: solid;
  border-color: #eeeeee;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.search-select-option:hover {
  background-color: #F4F4F4;
}
.search-select-option.is-active,
.search-select-option.is-active:hover {
  background-color: #F0F4F8;
  color: #334E68;
}
.search-select-empty {
  padding: 0.5rem 0.75rem;
  color: #b8c2cc;
}
.bg-input-button {
  background-color: inherit;
}
</style>
